import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SalesforceWriterForm from '../forms/salesforce-writer-form';
import { salesforceWriterValidationSchema } from '../schema/salesforceWriter';

export default function SalesforceWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Salesforce Writer Node Details',
        altText: 'Salesforce Writer Node',
        defaultLabel: 'Salesforce Writer Node',
      }}
    >
      <CommonNode
        FormComponent={SalesforceWriterForm}
        schemaResolver={salesforceWriterValidationSchema}
      />
    </NodeProvider>
  );
}
